// BestCards.jsx
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SingleProduct from "../../../../components/general/singleProduct/SingleProduct";
import MyContext from "../../../../contexts/AppContext";
import "../../../../assets/css/customer/subscreens/home/BestCards.css";
import { Button } from "react-bootstrap";
import { MdArrowForward } from "react-icons/md";

const BestCards = () => {
  const navigate = useNavigate();
  const { baseUrl, customerAuthToken } = useContext(MyContext);
  const [products, setProducts] = useState([]);

  const viewBestProducts = () => {
    axios
      .get(`${baseUrl}/customer/product/viewBestProducts`, {
        headers: {
          Authorization: `Bearer ${customerAuthToken}`,
        },
      })
      .then((response) => {
        setProducts(response.data.products || []);
      })
      .catch((error) => {
        console.log(error);
        setProducts([]);
      });
  };

  useEffect(() => {
    viewBestProducts();
  }, []);

  return (
    <section className="bestsellers-section">
      <div className="container">
        {/* Section Header */}
        <div className="bestproducts-section-header">
          <h2 className="BestProducts-section-title">Our Best</h2>
          <p className="section-subtitle">
            Discover Our Most Loved Handmade Treasures Crafted With Passion
          </p>
        </div>

        {/* Product Grid */}
        <div className="products-grid">
          {products.map((product) => (
            <SingleProduct key={product.id} product={product} />
          ))}
        </div>

        {/* View All Button */}
        <div className="view-all-section">
          <Button className="btn-view-all" onClick={() => navigate("/categories")}>
            VIEW ALL PRODUCTS
            <MdArrowForward size={22} className="ms-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BestCards;